export const InfoNotice = {
  // 画面タイトル
  Title: {
    BSC_HC_080_00x: 'お知らせ',
    BSC_HC_040_036: '通知設定',
    CALLING: '来局のご案内があります。',
  },
  Tab: {
    Notification: '通知',
    Info: 'お知らせ',
  },
  Mark: {
    New: 'NEW',
  },
  NotificationDateTime: {
    BeforeHour: '{0}分前',
    BeforeDay: '{0}時間前',
    BeforeYear: '{0}日前',
    AfterYear: '{0}年前',
  },
  //通知設定画面
  NoticeSettingPage: {
    All: '全て',
    UpdateBtnText: '更新する',
  },
};
